import { WorkspacePlanSettingsQuery } from "@repo/graphql/documents/workspace/query.generated";
import { SubscriptionsPricingNameChoices } from "@repo/graphql/gql/graphql";

export type PriceablePlan = NonNullable<
  WorkspacePlanSettingsQuery["subscription"]["listPlans"]
>[number];

/**
 * Picks the price for a plan/interval that matches the workspace's billing
 * country exactly. Returns `null` when the plan has no price listed for that
 * country/interval — callers must treat that as "not purchasable here", not
 * fall back to a different country's price.
 */
export const priceFor = (
  plan: PriceablePlan,
  interval: SubscriptionsPricingNameChoices,
  countryId: string | null,
) => {
  const pricing = plan.planpricingSet?.find(
    (pp) => pp.pricing.name?.enum === interval,
  );
  if (!pricing) return null;
  return pricing.priceSet.find((p) => p.country?.id === countryId) ?? null;
};

/** Strict check: does any pricing interval of this plan list a price for this exact country? */
export const hasPriceForCountry = (
  plan: PriceablePlan,
  countryId: string | null,
) => {
  if (!countryId) return false;
  return (plan.planpricingSet ?? []).some((pp) =>
    pp.priceSet.some((p) => p.country?.id === countryId),
  );
};
